import { defineComponent as _defineComponent } from 'vue'
import ExpandableTextBlock from "@/components/widgets/common/ExpandableTextBlock.vue"
import SearchInput from "@/components/widgets/common/SearchInput.vue"
import { ConsultantMissionLifecycleListFragmentFragment } from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantMissionsList',
  props: {
    missions: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const { timeAgo } = useUtilities()
const { router, routes } = useRouter()



const navigateToMission = (id: string) => {
  router.push({ name: routes.MissionDetail, params: { id } })
}

return { __sfc: true,timeAgo, router, routes, navigateToMission, ExpandableTextBlock, SearchInput }
}

})